import './NewsCard.scss';

function NewsCard({ image, alt, imgRights, title, content, date }) {
    const normalize = d => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const isNew = (() => {
        const [day, month, year] = date.split('/').map(Number);
        const newsDate = normalize(new Date(year, month - 1, day));
        const today = normalize(new Date());

        const diffTime = today - newsDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        return diffDays <= 20;
    })();

    return (
        <div className="news-card">
            <div className='image-section'>
                <img src={ image } alt={ alt }/>
                { imgRights }
            </div>

            <div className="text-section">
                <h3>{ title }</h3>
                <p>{ content }</p>

                <div className='info-section'>
                    <span>{ date }</span>

                    {isNew && (
                        <span className='label'>Novidade</span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default NewsCard;
